import {
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../../constants/app-constant";

const { V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE, V_SOCIAL, V_BLOG } = VERTICALS;

const journalistRankingFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistNOARanking,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistCCMRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistWCRanking,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistMAVRanking,
    vertical: [V_PRINT],
  },
];

const journalistTrendFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistNOATrend,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const journalistTonalityFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistTonalityNOARanking,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistTonalityCCMRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistTonalityMAVRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistTonalityWCRanking,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
];

export const journalistWidgetList = [
  {
    type: V_PRINT,
    name: "RANKING BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    id: 1,
    filterOption: journalistRankingFilter,
  },
  {
    id: 1,
    type: V_PRINT,
    name: "TREND BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: journalistTrendFilter,
  },
  {
    type: V_PRINT,
    name: "SENTIMENT BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: journalistTonalityFilter,
  },
  {
    type: V_ONLINE,
    name: "RANKING BY COMPANY (Online)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: journalistRankingFilter,
  },
  {
    type: V_ONLINE,
    name: "TREND BY COMPANY (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: journalistTrendFilter,
  },
  {
    type: V_ONLINE,
    name: "SENTIMENT BY COMPANY (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: journalistTonalityFilter,
  },
];

const publicationRankingFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationNOARanking,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.TopPublicationWordCount,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationCCMRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationMAVRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const publicationTrendFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationNOATrend,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOV_WC_TREND,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const publicationTonalityFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationTonalityNOARanking,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationTonalityCCMRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationTonalityMAVRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationTonalityWCRanking,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
];

export const publicationWidgetList = [
  {
    type: V_PRINT,
    name: "RANKING BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationRankingFilter,
  },
  {
    type: V_PRINT,
    name: "TREND BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: publicationTrendFilter,
  },
  // {
  //   type: V_PRINT,
  //   name: "SENTIMENT BY COMPANY (Print)",
  //   graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
  //   filterOption: publicationTonalityFilter,
  // },
  {
    type: V_ONLINE,
    name: "RANKING BY COMPANY (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationRankingFilter,
  },
  {
    type: V_ONLINE,
    name: "TREND BY COMPANY (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: publicationTrendFilter,
  },
  // {
  //   type: V_ONLINE,
  //   name: "SENTIMENT BY COMPANY (Online)",
  //   graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
  //   filterOption: publicationTonalityFilter,
  // },
];

const tonalityFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.TonalityNAORanking,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.TonalityCCMRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.TonalityMAVRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word Count",
    value: REPORT_TYPES.TonalityWordCount,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
];

const tonalityTrendFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.TonalityNAOTrend,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.TonalityCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.TonalityMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word Count",
    value: REPORT_TYPES.TonalityWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
];

export const tonalityWidgetList = [
  {
    type: V_PRINT,
    name: "SENTIMENT BY COMPANY",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: tonalityFilter,
  },
  {
    type: V_PRINT,
    name: "TREND BY COMPANY",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: tonalityTrendFilter,
  },
  {
    type: V_ONLINE,
    name: "SENTIMENT BY COMPANY",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: tonalityFilter,
  },
  {
    type: V_ONLINE,
    name: "TREND BY COMPANY",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: tonalityTrendFilter,
  },
];

export const sovRankingFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.SOVNOARanking,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVWC,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVCCMRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVMAVRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
];
export const sovTrendFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.SOV_NOA_TREND,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOV_WC_TREND,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOV_CCM_TREND,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOV_MAV_TREND,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
];

export const sovWidgetList = [
  {
    type: V_PRINT,
    name: "RANKING BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovRankingFilter,
  },
  {
    type: V_PRINT,
    name: "TREND BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: sovTrendFilter,
  },
  {
    type: V_ONLINE,
    name: "RANKING BY COMPANY (Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovRankingFilter,
  },
  {
    type: V_ONLINE,
    name: "TREND BY COMPANY (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: sovTrendFilter,
  },
];

export const taWidgetList = [
  {
    type: V_PRINT,
    name: "Thematic Analysis By Entity",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.ThematicAnalysisEntity,
        vertical: [V_PRINT, V_PRINT_AND_ONLINE],
      },
    ],
  },
  {
    type: V_PRINT,
    name: "Thematic Analysis By Tag",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.ThematicAnalysisTag,
        vertical: [V_PRINT, V_PRINT_AND_ONLINE],
      },
    ],
  },
  {
    type: V_ONLINE,
    name: "Thematic Analysis By Entity",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.ThematicAnalysisEntity,
        vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
      },
    ],
  },
  {
    type: V_ONLINE,
    name: "Thematic Analysis By Tag",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.ThematicAnalysisTag,
        vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
      },
    ],
  },
];

const kwFilter = [
  {
    label: "Keyword Cloud",
    value: REPORT_TYPES.KeywordCloudNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

export const keywordWidgetList = [
  {
    type: V_PRINT,
    name: "KEYWORD CLOUD (Print)",
    graph_type: GRAPH_TYPES.WORD_CLOUD,
    filterOption: kwFilter,
  },
  {
    type: V_ONLINE,
    name: "KEYWORD CLOUD (Online)",
    graph_type: GRAPH_TYPES.WORD_CLOUD,
    filterOption: kwFilter,
  },
];

const cityRankingFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.CityWiseNOARanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.CityWiseCCMRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.CityWiseMAVRanking,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const cityTrendFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.CityWiseNOATrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.CityWiseCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.CityWiseMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const cityTonalityFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.CityWiseTonality,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.CityWiseCCMTonality,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.CityWiseMAVTonality,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
];

export const cityWidgetList = [
  {
    type: V_PRINT,
    name: "RANKING BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: cityRankingFilter,
  },
  {
    type: V_PRINT,
    name: "Trend BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: cityTrendFilter,
  },
  {
    type: V_PRINT,
    name: "Tonality BY COMPANY (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: cityTonalityFilter,
  },
];

const reachFilter = [
  {
    label: "Reach Chart",
    value: REPORT_TYPES.Reach,
    vertical: [V_SOCIAL],
  },
];

export const reachWidgetList = [
  {
    type: V_SOCIAL,
    name: "Reach Chart",
    graph_type: GRAPH_TYPES.TABLE,
    filterOption: reachFilter,
  },
];

const influencerFilter = [
  {
    label: "Influencers",
    value: REPORT_TYPES.INFLUENCERS,
    vertical: [V_SOCIAL],
  },
];

export const influencerWidgetList = [
  {
    type: V_SOCIAL,
    name: "Influencers",
    graph_type: GRAPH_TYPES.TABLE,
    filterOption: influencerFilter,
  },
  {
    type: V_SOCIAL,
    name: "Influencers Trend",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.InfluencerWithDetail,
        vertical: [V_SOCIAL],
      },
    ],
  },
];

const topPostersFilter = [
  {
    label: "Top Posters Chart",
    value: REPORT_TYPES.TopPostersWithDetail,
    vertical: [V_SOCIAL],
  },
];

export const topPostersWidgetList = [
  {
    type: V_SOCIAL,
    name: "Top Posters Chart",
    graph_type: GRAPH_TYPES.TABLE,
    filterOption: topPostersFilter,
  },
  {
    type: V_SOCIAL,
    name: "Contributor Trend",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TopPostersTrend,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
